export default __webpack_public_path__ + "static/favicon-d515d66c80a929181556d0864be1bd14.ico";